<template>
  <div>
    <v-dialog v-model="showAreaDialog" width="800" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <v-layout align-center>
            <v-flex grow>
              {{ area.area }}
            </v-flex>
            <v-spacer />
            <v-btn flat icon class="align--right" @click.stop="close()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn-toggle multiple
                v-model="area_status"
                class="elevation-2 inspection__area-status"
              >
                <v-btn value="MESSY" flat color="primary" large>MESSY</v-btn>
                <v-btn value="DIRTY" flat color="primary" large>DIRTY</v-btn>
                <v-btn value="MOLDY" flat color="primary" large>MOLDY</v-btn>
                <v-btn value="MARKS" flat color="primary" large>MARKS</v-btn>
                <v-btn value="HOLES" flat color="primary" large>HOLES</v-btn>
                <v-btn value="NOT WORKING" flat color="primary" large>NOT WORKING</v-btn>
                <v-btn value="LEAKING" flat color="primary" large>LEAKING</v-btn>
                <v-btn value="DAMAGED" flat color="primary" large>DAMAGED</v-btn>
                <v-btn value="MISSING" flat color="primary" large>MISSING</v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex v-if="area.images && area.images.length > 0" xs12>
              <v-container grid-list-md class="px-0">
                <v-layout row wrap>
                  <v-flex v-for="(img, key) in area.images" :key="img.id" xs3>
                    <div class="inspection__area-image">
                      <v-img
                        class="elevation-2"
                        :src="getImagePath(img.name)"
                        aspect-ratio="1"
                        @click="openGallery(key)"
                      />
                      <v-btn small icon color="error" @click="deleteImage(key)">
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs12>
              <input
                v-show="false"
                ref="areaImage"
                type="file"
                accept="image/*"
                @change="uploadImage($event)"
              />
            </v-flex>
            <v-flex xs12 mt-4>
              <v-textarea
                v-model="area.note"
                label="Notes"
                rows="2"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 mt-4>
              <v-textarea
                v-model="area.action"
                label="Actions"
                rows="2"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            outline
            type="file"
            @click.stop.prevent="initUpload()"
          >
            <v-icon dark>attach_file</v-icon>Upload Image
          </v-btn>

          <v-btn color="primary" @click="saveArea(area, false)">
            <v-icon class="mr-1">save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div
      ref="areaGallery"
      class="pswp"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="pswp__bg"></div>
      <div class="pswp__scroll-wrap">
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
          <div class="pswp__top-bar">
            <div class="pswp__counter"></div>
            <button
              class="pswp__button pswp__button--close"
              title="Close (Esc)"
            ></button>
            <button
              class="pswp__button pswp__button--share"
              title="Share"
            ></button>
            <button
              class="pswp__button pswp__button--fs"
              title="Toggle fullscreen"
            ></button>
            <button
              class="pswp__button pswp__button--zoom"
              title="Zoom in/out"
            ></button>
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
          >
            <div class="pswp__share-tooltip"></div>
          </div>
          <button
            class="pswp__button pswp__button--arrow--left"
            title="Previous (arrow left)"
          ></button>
          <button
            class="pswp__button pswp__button--arrow--right"
            title="Next (arrow right)"
          ></button>
          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default'
import config from '@/config'
import Compressor from 'compressorjs'
import moment from 'moment'
import ConfirmDialog from '@/components/ConfirmDialog';

export default {
  name: 'InspectionArea',
  components: {
    ConfirmDialog,
  },
  props: {
    selectedArea: {
      type: Object,
      required: true,
    },
    showAreaDialog: {
      type: Boolean,
      default: true,
      required: true
    },
  },
  data() {
    return {
      inspectionId: this.$router.currentRoute.params.id,
    }
  },
  computed: {
    ...mapGetters({
      task: 'Tasks/getSelectedTask',
    }),
    area() {
      return this.selectedArea;
    },
    area_status: {
      get: function () {
        if (!this.selectedArea || !this.selectedArea.status) {
          return [];
        }
        return this.selectedArea.status.split(',');
      },
      // setter
      set: function (newValue) {
        const names = newValue.join(',')
        this.selectedArea.status = names;
      }
    }
  },
  methods: {
    ...mapActions({
      upload: 'HouseList/Inspections/upload',
      save: 'HouseList/Inspections/saveArea',
    }),
    close() {
      this.$emit('update:showAreaDialog', false)
    },
    initUpload() {
      this.$refs.areaImage.click()
    },
    uploadImage(event) {
      let localFile = event ? event.target.files[0] : null
      if (!localFile) {
        return
      }
      let that = this;
      let comp = new Compressor(localFile, {
        quality: 0.4,
        success(result) {
          // debugger
          that.upload({
            file: result,
            area: that.area,
          })
        },error(err){
          console.log(err);
        }
      })
      comp = null;
    },
    saveArea(area, isEditing) {
      this.save(area)

      if (!isEditing) {
        this.close()
      }
    },
    getImagePath(imageUrl) {
      const house_id = this.task.house_id;
      const timestamp = this.task.timestamp;
      const date = moment.unix(timestamp).format("YYYY-MM-DD")
      const filename = imageUrl.split('\\').pop().split('/').pop();
      const path = `${config.s3HouseUrl}${house_id}/inspections/${date}/images/${filename}`;
      // console.log(path)
      return path

    },
    deleteImage(index) {
      this.$confirm({
        title: 'Delete image from this area',
        message: 'Are you sure to delete this image from the gallary?',
        button: {
          yes: 'Yes',
          no: 'No'
        },
        callback: confirm => {
          if (confirm) {
            this.area.images.splice(index, 1)
            this.uploadImage()
          }
        }
      });
    },
    openGallery(index) {
      const images = this.area.images.map((image) => {
        return {
          src: this.getImagePath(image.name),
          w: 1024,
          h: 768,
        }
      })
      const gallery = new PhotoSwipe(
        this.$refs.areaGallery,
        PhotoSwipeDefaultUI,
        images,
        { index }
      )
      gallery.init()
    },
  },
}
</script>
<style lang="stylus" scoped>
.v-btn-toggle .v-btn {
  opacity: 0.8;
}

.v-btn-toggle .v-btn:hover, .v-btn-toggle .v-btn:focus, .v-btn-toggle .v-btn.v-btn--active {
  color: #fff !important;
}

.inspection__area-status {
  .v-btn--active:before, .v-btn:hover:before, .v-btn:focus:before {
    background-color: var(--v-primary-base);
    opacity: 1;
  }
}

.inspection__area-image .v-image {
  cursor: pointer;
}

.inspection__area-image {
  position: relative;
}

.inspection__area-image .v-btn {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
}
</style>
